<template>
  <span class="px-3">
    <EditOnClick v-model="value" :type="row.type" :editable="row.editable" />
    <button
      class="btn btn-secondary btn-sm btn-no-r"
      :title="$t(`orderProducts.addItem`)"
      v-on:click="show(false, true)"
      :disabled="extraRow > 1"
    >
      <BaseIcon name="plus" />
    </button>
    <button
      class="btn btn-secondary btn-sm btn-no-r btn-no-l"
      :title="$t(`orderProducts.changeItem`)"
      v-on:click="show(true, true)"
      :disabled="extraRow === 3"
    >
      <BaseIcon name="change" />
    </button>
    <button
      class="btn btn-secondary btn-sm btn-no-l"
      :title="$t(`orderProducts.returnItem`)"
      v-on:click="show(true, false)"
      :disabled="extraRow === 3"
    >
      <BaseIcon name="trash" />
    </button>
  </span>
</template>
<script>
import { defineAsyncComponent } from "vue";
import EditOnClick from "@/components/inputs/EditOnClick";
const BaseIcon = defineAsyncComponent(() => import("../../icons/BaseIcon.vue"));

export default {
  name: "OrderProducts",
  components: { EditOnClick, BaseIcon },
  props: {
    id: Number,
    type: String,
    row: Object,
    modelValue: Object,
    extraRow: String,
  },
  data() {
    return {
      value: this.modelValue,
      data: undefined,
      products: null,
      delivery: undefined,
      addElement: false,
      removeElement: false,
      deliveredStatus: null,
      shop: undefined,
    };
  },
  watch: {
    value() {
      this.$emit("update:modelValue", this.value);
      this.$emit("change");
    },
    modelValue() {
      this.value = this.modelValue;
    },
  },
  methods: {
    show(remove, add) {
      window.apps.callEvent("order:openChange", this.id, remove, add);
    },
  },
  emits: ["update:modelValue", "change"],
};
</script>
